(() => {
  'use strict';
  if (window.avWorkforceComparison) return;
  window.avWorkforceComparison = true;
  const cache = new Map();
  const states = new WeakMap();
  const parse = node => { try { return JSON.parse(node?.textContent || 'null'); } catch { return null; } };
  const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency, minimumFractionDigits: amount % 100 === 0 ? 0 : 2
  }).format(amount / 100);
  async function price(url, target, chosen) {
    const endpoint = new URL(url); endpoint.searchParams.set('view', 'avontic-selection');
    const key = endpoint.toString();
    if (!cache.has(key)) {
      if (cache.size > 64) cache.delete(cache.keys().next().value);
      cache.set(key, fetch(endpoint, { credentials: 'same-origin', signal: AbortSignal.timeout(10000) }).then(async response => {
        if (!response.ok) throw Error('request');
        return response.json();
      }).catch(error => { cache.delete(key); throw error; }));
    }
    const result = await cache.get(key);
    if (result.handle !== target.handle || !result.variant?.available || !Number.isFinite(result.variant.price) ||
        !chosen.every(item => item.position < 1 || result.variant.options[item.position - 1] === item.value.name)) throw Error('unavailable');
    return result;
  }
  document.addEventListener('avontic:workforce-match', async event => {
    const card = event.target;
    const root = card.closest('[data-av-workforce-comparison]');
    if (!root) return;
    const {source, selected, target, result, current, sourceUrl, targetUrl} = event.detail;
    const output = card.querySelector('[data-av-wc-price]');
    const delta = card.querySelector('[data-av-wc-delta]');
    const status = root.querySelector('[data-av-wc-status]');
    const text = parse(root.querySelector('[data-av-wc-text]')) || {};
    card.dataset.fitStatus = current ? 'current' : result.blocked ? result.reason : result.questions.length ? 'choice' : 'matched';
    const complete = selected.length === source.options.length && selected.every(Boolean);
    const signature = JSON.stringify([selected.map(v => v?.id), targetUrl, result.blocked, result.questions]);
    if (states.get(card)?.signature === signature) return;
    const state = {signature}; states.set(card, state);
    if (output) output.textContent = output.dataset.from;
    if (delta) delta.textContent = delta.dataset.from || '';
    if (current && status) status.textContent = complete ? '' : (text.choose || '');
    if (result.blocked && result.reason === 'unavailable' && output) output.textContent = text.unavailable;
    if (!complete || result.blocked || result.questions.length || !target) return;
    try {
      const chosen = selected.map((value, i) => ({position: source.options[i].position, value}));
      const [sourcePrice, targetPrice] = await Promise.all([price(sourceUrl, source, chosen), price(targetUrl, target, result.chosen)]);
      if (!root.isConnected || states.get(card) !== state) return;
      const currency = targetPrice.currency || root.dataset.currency;
      if (output) output.textContent = money(targetPrice.variant.price, currency);
      if (!current && delta && sourcePrice.currency === targetPrice.currency) {
        const difference = targetPrice.variant.price - sourcePrice.variant.price;
        delta.textContent = difference > 0 ? '+' + money(difference, currency) : difference === 0 ? (text.same || '') : '';
      }
    } catch (error) {
      if (!root.isConnected || states.get(card) !== state) return;
      if (output) output.textContent = output.dataset.from;
      if (delta && !current) delta.textContent = error.message === 'unavailable' ? (text.unavailable || '') : (delta.dataset.from || '');
      // A future interaction retries transient failures; successful checks stay cached.
      if (error.message !== 'unavailable') states.delete(card);
    }
  });
})();